// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TicketManagment-main-container {
  height: calc(100vh - 21em);

  margin-top: 19px !important;
}
.TicketManagment-Container001{
  padding: 0px 24px;
}
.Ticket-container-render{
  padding: 0px 24px;
}
.Ticket-text {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.profile-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Ticket-main-header {
  align-items: center;
  margin-top: 33px;
  /* cursor: pointer; */
}
.Ticket-text-section {
  display: flex;
  gap: 24px;
}
.ticket-header-text {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.TicketHeaderActive {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-bottom: 1px solid #148dfd;
  padding-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/ProfileManagment/style.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;;EAE1B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":[".TicketManagment-main-container {\n  height: calc(100vh - 21em);\n\n  margin-top: 19px !important;\n}\n.TicketManagment-Container001{\n  padding: 0px 24px;\n}\n.Ticket-container-render{\n  padding: 0px 24px;\n}\n.Ticket-text {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.profile-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.Ticket-main-header {\n  align-items: center;\n  margin-top: 33px;\n  /* cursor: pointer; */\n}\n.Ticket-text-section {\n  display: flex;\n  gap: 24px;\n}\n.ticket-header-text {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.TicketHeaderActive {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  border-bottom: 1px solid #148dfd;\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
